'use strict';

angular.module('licensure.services')
    .factory('TrainingUsers', ['$http', '$q', function ($http, $q) {

    	var getTrainingsForReimbursement = function (args) {
    		var d = $q.defer();

            $http
                .get(apiLocation + '/api/TrainingUsersReimbursement', {
    			    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    d.reject(response);
                });

    		return d.promise;
    	}

    	return {
            getTrainingsForReimbursement: getTrainingsForReimbursement,
    	}
    }])
;